/**
 * Страница менеджера: карточка пользователя (userinfo).
 *
 * Маркер инициализации — наличие #saveNoteBtn (есть только на этой странице).
 * Конфиг (csrf, route, userId) — в window.managerUserInfoConfig.
 *
 * Функционал:
 *   - сохранение manager_note по AJAX;
 *   - фильтрация таблицы проектов по выбранным менеджерам (чекбоксы);
 *   - комбинированный поиск по уже отфильтрованным строкам;
 *   - toggle поля поиска (active class).
 */

function init() {
    // На userproject есть свой #saveNoteBtn (другая страница) — поэтому guard по #noteForm,
    // которая существует только на manager/userinfo.
    if (!document.getElementById('noteForm')) return;

    const config = window.managerUserInfoConfig;
    if (!config) {
        console.error('[manager-user-info] window.managerUserInfoConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-user-info] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};

    $(() => {
        // Сохранение заметки
        $('#saveNoteBtn').on('click', function (e) {
            e.preventDefault();

            $.ajax({
                url: config.routes.saveNote,
                type: 'POST',
                data: {
                    _token: config.csrfToken,
                    manager_note: $('#manager_note').val(),
                },
                success(response) {
                    if (response.success) {
                        showToast('success', 'Manager note saved successfully');
                        $('#saveNoteBtn').addClass('btn_success');
                        setTimeout(() => $('#saveNoteBtn').removeClass('btn_success'), 2000);
                    } else {
                        showToast('error', response.message || 'Failed to save note');
                    }
                },
                error() {
                    showToast('error', 'Error saving note');
                },
            });
        });

        function filterProjectsByManager() {
            const selectedManagers = [];
            $('.adm_r_filter_select input[type="checkbox"]:checked').each(function () {
                selectedManagers.push(parseInt($(this).val(), 10));
            });

            let visibleCount = 0;

            $('.project-row').each(function () {
                const $row = $(this);
                const managerIds = JSON.parse($row.attr('data-manager-ids') || '[]');

                if (selectedManagers.length === 0) {
                    $row.show();
                    visibleCount++;
                    return;
                }

                const hasMatch = selectedManagers.some(id => managerIds.indexOf(id) !== -1);
                if (hasMatch) {
                    $row.show();
                    visibleCount++;
                } else {
                    $row.hide();
                }
            });

            if (visibleCount === 0 && selectedManagers.length > 0) {
                if ($('.no-projects-row').length === 0) {
                    $('.t_user_projects tbody').append(
                        '<tr class="no-projects-row"><td colspan="5" style="text-align: center;"><p>No projects found for selected managers</p></td></tr>'
                    );
                } else {
                    $('.no-projects-row').show();
                }
            } else {
                $('.no-projects-row').hide();
            }
        }

        $('.adm_r_filter_select input[type="checkbox"]').on('change', filterProjectsByManager);

        // Поиск по проектам с учётом фильтрации
        $('#adm_search_input').on('keyup', function () {
            const searchText = $(this).val().toLowerCase();
            filterProjectsByManager();
            if (!searchText) return;
            $('.project-row:visible').each(function () {
                const row = $(this);
                if (row.text().toLowerCase().indexOf(searchText) === -1) {
                    row.hide();
                }
            });
        });

        // Активация поля поиска
        $('.adm_search_button').on('click', function (e) {
            e.preventDefault();
            $('#adm_search_block').toggleClass('active');
            if ($('#adm_search_block').hasClass('active')) {
                $('#adm_search_input').focus();
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
